import React, { useState } from "react";
import { useRive, Layout, Fit, Alignment } from "@rive-app/react-canvas";
import { useInView } from "react-intersection-observer";
import envelope from "./rives/envelope.riv";
import logo from "./rives/logo_2.riv";

export const RiveLogo = ({ classes, triggerOnce }) => {
  const [loading, isLoading] = useState(false);
  const [viewRef, isInView] = useInView({
    triggerOnce: triggerOnce,
    // rootMargin: "200px"
    threshold: 0.2,
  });

  const { RiveComponent } = useRive({
    src: logo,
    layout: new Layout({
      fit: Fit.Fill,
      alignment: Alignment.Center,
    }),
    stateMachines: "State Machine 1",
    artboard: "Artboard",
    autoplay: true,
    onLoad: () => isLoading(true),
  });

  return (
    <>
      <div className={classes} ref={viewRef}>
        {loading === false && (
          <div className="loader">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 401 251"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M66.8765 192.41V41.8746H0.650635V5.73364H104.766V192.41H66.8765Z"
                fill="white"
              />
              <path
                d="M182.218 5.73364H133.48V41.8746H182.218V5.73364Z"
                fill="white"
              />
              <path
                d="M229.904 192.41V110.836H171.397V192.41H133.48V74.8751H229.904V5.73364H267.821V192.41H229.904Z"
                fill="white"
              />
              <path
                d="M400.651 81.0015H296.535V117.142H400.651V81.0015Z"
                fill="white"
              />
              <path
                d="M400.651 5.73364H296.535V41.8746H400.651V5.73364Z"
                fill="white"
              />
              <path
                d="M400.65 156.269H296.535V192.41H400.65V156.269Z"
                fill="white"
              />
              <path
                d="M66.8765 192.41V41.8746H0.650635V5.73364H104.766V192.41H66.8765Z"
                fill="white"
              />
              <path
                d="M182.218 5.73364H133.48V41.8746H182.218V5.73364Z"
                fill="white"
              />
              <path
                d="M229.904 192.41V110.836H171.397V192.41H133.48V74.8751H229.904V5.73364H267.821V192.41H229.904Z"
                fill="white"
              />
              <path
                d="M400.651 81.0015H296.535V117.142H400.651V81.0015Z"
                fill="white"
              />
              <path
                d="M400.651 5.73364H296.535V41.8746H400.651V5.73364Z"
                fill="white"
              />
              <path
                d="M400.65 156.269H296.535V192.41H400.65V156.269Z"
                fill="white"
              />
              <path
                d="M118.745 227.161H120.607L128.595 243.996H126.463L124.412 239.569H114.885L112.807 243.996H110.783L118.772 227.161H118.745ZM123.629 237.844L119.635 229.349L115.641 237.844H123.629Z"
                fill="white"
              />
              <path
                d="M162.706 244.279C161.33 244.279 160.089 244.048 158.982 243.61C157.876 243.172 156.958 242.555 156.175 241.782C155.393 241.01 154.799 240.083 154.394 239.054C153.99 238.024 153.774 236.891 153.774 235.707V235.656C153.774 234.497 153.99 233.416 154.421 232.361C154.853 231.306 155.447 230.405 156.202 229.607C156.958 228.809 157.903 228.165 158.982 227.702C160.062 227.238 161.249 227.007 162.571 227.007C163.3 227.007 163.975 227.058 164.595 227.161C165.216 227.264 165.783 227.393 166.296 227.599C166.835 227.779 167.321 228.036 167.78 228.294C168.239 228.577 168.697 228.886 169.129 229.246L167.861 230.688C167.537 230.405 167.186 230.147 166.808 229.915C166.43 229.684 166.053 229.478 165.621 229.323C165.189 229.169 164.73 229.015 164.218 228.937C163.705 228.834 163.138 228.783 162.517 228.783C161.546 228.783 160.655 228.963 159.846 229.323C159.036 229.684 158.334 230.173 157.741 230.791C157.147 231.408 156.688 232.129 156.364 232.979C156.041 233.802 155.852 234.703 155.852 235.63V235.682C155.852 236.686 156.014 237.612 156.337 238.462C156.661 239.311 157.12 240.032 157.714 240.65C158.307 241.267 159.036 241.757 159.9 242.117C160.763 242.477 161.708 242.632 162.787 242.632C163.786 242.632 164.73 242.477 165.621 242.143C166.511 241.808 167.24 241.422 167.861 240.959V236.814H162.517V235.115H169.75V241.782C168.94 242.477 167.915 243.095 166.727 243.584C165.54 244.099 164.191 244.331 162.706 244.331V244.279Z"
                fill="white"
              />
              <path
                d="M196.71 227.264H209.367V228.989H198.68V234.704H208.233V236.428H198.68V242.272H209.501V243.996H196.71V227.264Z"
                fill="white"
              />
              <path
                d="M236.029 227.264H237.892L248.929 240.65V227.264H250.845V243.971H249.28L237.973 230.25V243.971H236.056V227.264H236.029Z"
                fill="white"
              />
              <path
                d="M286.36 244.279C285.092 244.279 283.931 244.048 282.852 243.61C281.772 243.172 280.855 242.555 280.072 241.782C279.289 241.01 278.669 240.109 278.237 239.054C277.805 237.998 277.562 236.891 277.562 235.682V235.63C277.562 234.446 277.778 233.339 278.237 232.284C278.696 231.228 279.289 230.302 280.072 229.529C280.855 228.757 281.799 228.114 282.879 227.676C283.958 227.213 285.146 227.007 286.441 227.007C287.25 227.007 287.952 227.058 288.6 227.187C289.248 227.316 289.841 227.496 290.381 227.727C290.921 227.959 291.434 228.242 291.919 228.551C292.378 228.886 292.837 229.246 293.269 229.632L291.919 231.022C291.164 230.353 290.354 229.813 289.517 229.375C288.654 228.937 287.628 228.731 286.414 228.731C285.442 228.731 284.552 228.912 283.715 229.246C282.879 229.607 282.177 230.07 281.556 230.713C280.936 231.331 280.477 232.052 280.126 232.902C279.775 233.725 279.613 234.626 279.613 235.579V235.63C279.613 236.608 279.775 237.509 280.126 238.333C280.477 239.157 280.936 239.903 281.556 240.521C282.177 241.139 282.879 241.628 283.715 241.988C284.552 242.349 285.442 242.529 286.414 242.529C287.628 242.529 288.654 242.323 289.517 241.885C290.381 241.448 291.245 240.881 292.081 240.109L293.377 241.319C292.918 241.757 292.459 242.168 291.973 242.529C291.487 242.889 290.948 243.198 290.381 243.455C289.814 243.713 289.194 243.919 288.546 244.048C287.898 244.202 287.17 244.253 286.36 244.253V244.279Z"
                fill="white"
              />
              <path
                d="M324.816 237.381L317.53 227.29H319.932L325.815 235.656L331.752 227.29H334.046L326.759 237.355V243.996H324.789V237.381H324.816Z"
                fill="white"
              />
            </svg>
          </div>
        )}

        {isInView && <RiveComponent className="rive-logo" />}
      </div>
    </>
  );
};

export const RiveLetter = () => {
  const [ref, isInView] = useInView({
    triggerOnce: false,
    // rootMargin: "200px"
    threshold: 0.2,
  });

  const { RiveComponent } = useRive({
    src: envelope,
    layout: new Layout({
      fit: Fit.FitHeight,
      alignment: Alignment.BottomLeft,
    }),

    stateMachines: "Letter Machine",
    autoplay: true,
  });

  return (
    <div className="envelope" ref={ref}>
      {isInView && <RiveComponent />}
    </div>
  );
};
